// extracted by mini-css-extract-plugin
export var h1 = "customHeadline-module--h1--31bfe";
export var h2 = "customHeadline-module--h2--d3d1c";
export var h3 = "customHeadline-module--h3--9dc4b";
export var h4 = "customHeadline-module--h4--13541";
export var h5 = "customHeadline-module--h5--91b3d";
export var h6 = "customHeadline-module--h6--c8360";
export var headlineStyle = "customHeadline-module--headlineStyle--b4888";